import { render, staticRenderFns } from "./fixedPriceDetails.vue?vue&type=template&id=60440f20&scoped=true"
import script from "./fixedPriceDetails.vue?vue&type=script&lang=ts"
export * from "./fixedPriceDetails.vue?vue&type=script&lang=ts"
import style0 from "./fixedPriceDetails.vue?vue&type=style&index=0&id=60440f20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60440f20",
  null
  
)

export default component.exports